export const schedulerStyle = `

button {
  border-color: #2b2b2b !important;
  border-radius: 0!important;
  color: #2b2b2b !important;
  font-family: 'Montserrat' !important;
  font-size: 10px !important;
  font-weight: 400 !important;
  letter-spacing: 1.2px !important;
  text-transform: uppercase !important;
}
button.button-primary {
  background-color: #2b2b2b !important;
  color: #fff !important;
}
button.button-primary:hover {
  background-color: #3d3d3d !important;
}
button.button-basic:hover {
  border-color: #bea06e !important;
}
button.tab.active {
  border-color: #bea06e !important;
  color: #bea06e !important;
}
.configurations {
  border-radius: 0!important;
}
::part(actions__dropdown-button) {
  border-color: #2b2b2b !important;
  border-radius: 0px;
}
::part(actions__dropdown-button):hover {
  border-color: #bea06e !important;
  outline: none;
}
.sc-nylas-editor-tabs.saved-changes {
  color: #bea06e !important;
}
.sc-nylas-editor-tabs.unsaved-changes {
  color: #3d3d3d !important;
}
nylas-event-title::part(net__title),
nylas-event-description::part(nedesc__textarea),
nylas-event-duration::part(ned__input_dropdown-input),
nylas-event-duration::part(ned__dropdown-button),
nylas-event-location::part(nel__dropdown-button),
nylas-availability-picker::part(nap__timezone-button),
nylas-availability-picker::part(nap__time-picker-input),
nylas-booking-confirmation-redirect::part(nbcr__dropdown-button),
nylas-buffer-time::part(nbt__dropdown-button-before),
nylas-buffer-time::part(nbt__dropdown-button-after),
nylas-min-booking-notice::part(tps__period-dropdown-button),
nylas-min-booking-notice::part(tps__number-dropdown-button),
nylas-limit-future-bookings::part(tps__period-dropdown-button),
nylas-limit-future-bookings::part(tps__number-dropdown-button),
nylas-min-cancellation-notice::part(tps__period-dropdown-button),
nylas-min-cancellation-notice::part(tps__number-dropdown-button),
nylas-cancellation-policy::part(ncpolicy__textarea),
nylas-timeslot-interval::part(nti__dropdown-button),
nylas-additional-participants::part(nap__add-participant),
nylas-booking-form-config::part(nbfc__add_field-button)
{
  font-family: 'Montserrat' !important;
  outline-color: #bea06e !important;
}
nylas-participant-booking-calendars::part(npbc__participant-toggle-container),
nylas-connected-calendars::part(nccals__toggle-container),
nylas-availability-picker::part(nap__time-range),
nylas-additional-participants::part(nap__input),
nylas-confirmation-email::part(nce__confirmation-email-toggle--container),
nylas-page-name::part(nces__drawer-toggle--container)
{
  --nylas-font-family: '"Montserrat", sans-serif',
  --nylas-primary: #bea06e !important;
}
nylas-participants-custom-availability::part(npca_toggle-slider),
nylas-confirmation-email::part(nce_toggle-slider),
nylas-disable-emails::part(nde_toggle-slider)
{
  --nylas-base-300: #3d3d3d !important;
  --nylas-success: #bea06e !important;
}
nylas-availability-picker::part(nap__time-picker-input):hover {
  border-color: #bea06e !important;
}
nylas-additional-participants::part(nap__add-participant):hover,
nylas-availability-picker::part(nap__add-time-range):hover {
  color: #bea06e !important;
}
nylas-participant-booking-calendars::part(npbc__header),
nylas-connected-calendars::part(nccals__header),
nylas-availability-picker::part(nap__header),
nylas-additional-participants::part(nap__subtitle),
nylas-buffer-time::part(nbt__header),
nylas-booking-form-config::part(nbfc__header),
nylas-confirmation-email::part(nce__header),
nylas-confirmation-email::part(nce__summary),
nylas-page-name::part(nces__header),
nylas-participants-custom-availability::part(npca__header),
.scheduler-editor.sc-nylas-editor-tabs .form-contents.sc-nylas-editor-tabs p.sc-nylas-editor-tabs,
.header .description p {
  --nylas-base-600: #3d3d3d !important;
}
nylas-calendar-picker::part(ncp__dropdown-button) {
  --nylas-font-family: '"Montserrat", sans-serif';
}
nylas-booking-form-config::part(nbfc__form_field-header) {
  --nylas-base-500: #3d3d3d !important;
  --nylas-base-600: #3d3d3d !important;
}
nylas-booking-form-config::part(nap__add-time-range) {
  font-family: 'Montserrat' !important;
}
select-dropdown::part(sd_dropdown-labelhtml):hover,
nylas-booking-form-config::part(nap__add-time-range):hover {
  --nylas-primary: #bea06e !important;
}
`;

export const localSchedulerCreateRootStyle = `
.nylas-select-event-type div.header button-component button:hover,
.nylas-select-event-type div.header button-component button:active{
  --nylas-primary: #bea06e !important;
}
.nylas-select-event-type{
  --nylas-font-family: '"Montserrat", sans-serif';
}
.nylas-select-event-type div.header button-component button{
  font-size: 18px !important;
}
`;

export const localSchedulerRootStyle = `
.nylas-event-location,
.nylas-availability-picker .content,
.nylas-booking-form-config .content,
.nylas-min-booking-notice,
.nylas-limit-future-bookings,
.nylas-min-cancellation-notice,
.nylas-additional-participants__add,
::part(sd_dropdown-button-selected-label),
::part(msd_dropdown-button-selected-label) {
  font-family: 'Montserrat' !important;
}

.radio-group,
.checkbox-container {
  --nylas-font-family: 'Montserrat', sans-serif !important;
}

::part(sd_dropdown-button),
::part(msd_dropdown-button),
::part(tps__number-dropdown-button),
::part(tps__period-dropdown-button) {
  outline-color: #bea06e !important;
  --nylas-font-family: 'Montserrat', sans-serif !important;
}

nylas-availability-picker::part(nap__time-picker-input):hover {
  border-color: #bea06e !important;
}

input[type=date],
::part(ic__label),
::part(ic__input),
::part(id_dropdown-input),
textarea-component::part(tc__label),
textarea-component::part(tc__textarea),
nylas-availability-picker::part(nap__time-picker-input),
.nylas-event-location input {
  font-family: 'Montserrat' !important;
  outline-color: #bea06e !important;
}

.nylas-event-location select-dropdown {
  width: 218px !important;
}

textarea-component::part(tc__label) {
  font-size: 14px;
}

.nylas-availability-picker .content .availability .availability-day button:hover,
.nylas-availability-picker .content .availability .availability-day button:active,
.nylas-additional-participants__input_wrapper button:hover,
.nylas-additional-participants__input_wrapper button:active,
input-dropdown.sc-time-period-selector,
.nylas-participants-custom-availability .content .participant-toggle .chevron:hover,
.nylas-participants-custom-availability .content .participant-toggle .chevron:active,
.nylas-booking-form-config .content .additional_fields .form-field_header_actions button:hover,
.nylas-booking-form-config .content .additional_fields .form-field_header_actions button:active,
.nylas-booking-form-config .content .additional_fields .form-field_header_actions .chevron:hover,
.nylas-booking-form-config .content .additional_fields .form-field_header_actions .chevron:active,
.nylas-confirmation-email .header .confirmation-email-toggle .chevron:hover,
.nylas-confirmation-email .header .confirmation-email-toggle .chevron:active,
.nylas-page-name .header .drawer-toggle .chevron:hover,
.nylas-page-name .header .drawer-toggle .chevron:active,
.nylas-participant-booking-calendars .content .participant-toggle .chevron:hover,
.nylas-participant-booking-calendars .content .participant-toggle .chevron:active,
.nylas-connected-calendars .content .participant-toggle .chevron:hover,
.nylas-connected-calendars .content .participant-toggle .chevron:active,
.selected-options .selected-option button:hover,
.dropbtn:hover, .dropbtn:active,
.nylas-booking-form-config .content .options-container .options .option button:hover,
.nylas-booking-form-config .content .options-container .options .option button:active,
.cards-container .nylas-reminder-email .reminder-open-close-toggle .chevron:hover,
.cards-container .nylas-reminder-email .reminder-open-close-toggle .chevron:active {
  --nylas-primary: #bea06e !important;
}
.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__preview h4,
.nylas-buffer-time .nylas-buffer-time__body .nylas-buffer-time__preview .event-slot,
.radio-group label .radio-option p .description,
.nylas-additional-participants__subtitle,
.nylas-booking-calendar-picker .header p,
.nylas-customize-booking-settings .header p,
.nylas-disable-emails .header p {
  --nylas-base-600: #3d3d3d !important;
}
button.button-basic.sc-button-component {
  --nylas-base-700: #3d3d3d !important;
  --nylas-font-family: 'Montserrat', sans-serif !important;
}
button.button-basic.sc-button-component:hover {
  border-color: #bea06e !important;
  --nylas-base-700: #bea06e !important;
}
.nylas-page-name .nylas-page-name__input-wrapper:focus {
  outline-color: #bea06e !important;
}

span.help-text {
  --nylas-base-500: #3d3d3d !important;
}

.nylas-additional-participants__add:hover,
.nylas-additional-participants__add:active{
  font-family: 'Montserrat' !important;
  --nylas-primary: #bea06e !important;
}

.nylas-availability-picker .content .availability .availability-day .day input[type="checkbox"],
.nylas-booking-form-config .content  .required-input input[type=checkbox],
.radio-group label .radio-option input[type=radio i],
.dropdown-content ul li label input {
  accent-color: #3d3d3d !important;
}
label input[type="checkbox"]:checked ~ .checkmark {
  --nylas-primary: #3d3d3d !important;
}
label .checkmark {
  --nylas-primary: #3d3d3d !important;
  outline-color: #3d3d3d !important;
}
.nylas-event-location label,
.nylas-event-location select-dropdown::part(sd_dropdown-button-selected-label) {
  font-family: 'Montserrat' !important;
}

.time-picker,
.time-picker input,
.time-picker input:hover,
.time-picker input:active,
select-dropdown::part(sd_dropdown-button){
  font-family: 'Montserrat' !important;
  outline-color: #bea06e !important;
  --nylas-primary: #bea06e !important;
}
`;

export const localSchedulerPreviewRootStyle = `
::part(ic__label),
::part(ic__input),
::part(id_dropdown-input),
::part(sd_dropdown_label),
::part(sd_dropdown-button),
textarea-component::part(tc__label),
textarea-component::part(tc__textarea) {
  font-family: 'Montserrat' !important;
  outline-color: #bea06e !important;
}

.radio-group,
.checkbox-container {
  --nylas-font-family: 'Montserrat', sans-serif !important;
}

::part(ic__input)::placeholder,
::part(nbf__input-textfield)::placeholder {
  color: #bea06e !important;
}

.radio-group label .radio-option input[type=radio i],
.dropdown-content ul li label input {
  accent-color: #3d3d3d !important;
}
`;
